import Grid from "@mui/material/Grid2";
import { useWallets } from "api/wallets";
import { SelectInput } from "components/FormControls/Select/Select";
import { trackedMetrics } from "components/Layout/Leaderboards/utils";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { useState } from "react";

export const TrackedMetricsSection = ({
  isEditMode,
}: {
  isEditMode: boolean;
}) => {
  const { message } = useMessage();
  const [walletTypeSearch, setWalletTypeSearch] = useState("");
  const { useInfiniteWalletsList } = useWallets();

  const {
    data: infiniteWalletsList,
    size: walletsSize,
    setSize: setWalletsSize,
    isValidating,
  } = useInfiniteWalletsList({
    filters: walletTypeSearch
      ? [
          {
            condition: "like",
            query: "code",
            value: walletTypeSearch,
          },
        ]
      : [],
    order: "asc",
    sortKey: "code",
  });

  const { infiniteData: walletsList, anyElementsToFetch: anyWalletsToFetch } =
    useManageInfiniteScroll(infiniteWalletsList || []);

  return (
    <Grid container spacing={12} mt={4}>
      <Grid size={{ xs: 6 }}>
        <SelectInput
          width="100%"
          data-test-id="leaderboard-form-tracked-metric"
          items={trackedMetrics.map(({ id, label }) => ({
            id,
            label: message({ id: label }),
            disabled: id !== "numberOfActiveUnitsInWallet",
          }))}
          label={message({
            id: "metric",
          })}
          name="trackedMetric.metric"
          disabled={isEditMode}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <SelectInput
          width="100%"
          displaySearch
          data-test-id="leaderboard-form-tracked-metric-wallet"
          name="trackedMetric.wallet"
          items={walletsList.map((wallet) => ({
            label: wallet.name,
            id: wallet.code,
          }))}
          asyncSearch={(searchedQuery) => setWalletTypeSearch(searchedQuery)}
          label={message({ id: "walletType" })}
          anyElementsToFetch={anyWalletsToFetch}
          loadMoreElements={() =>
            !isValidating && setWalletsSize(walletsSize + 1)
          }
          disabled={isEditMode}
        />
      </Grid>
    </Grid>
  );
};
